/**
 * Brand palette for JS consumers (Recharts strokes/fills, inline styles).
 * Values mirror styles/brand-tokens.css — PHASE-1.5-BRAND-SPEC.md §1 is the
 * source of truth. Do not add colors that are not in the spec.
 */
export const BRAND = {
  ink900: '#0F172A',
  ink950: '#0E1729',
  surfaceRaised: '#161F30',
  cream: '#FAF7F2',
  gold: '#CA9612',
  goldBright: '#DB9E33',
  tealDeep: '#0F766E',
  tealChip: '#E2F3F0',
  mintPanel: '#E9F1EC',
  sandPanel: '#F6EFE1',
  chipGold: '#F7EAC2',
  chipRose: '#FCD8D8',
  chipLavender: '#EFEBFE',
  violetFlow: '#A78BFA',
  tealFlow: '#2DD4BF',
  flowBlue: '#0066FF',
  flowBlueHover: '#3385FF',
  flowBlueChip: '#E3EDFF',
  aiAccent: '#8B5CF6', /* AI-feature accents (Q5 amendment) */
  aiAccentHover: '#7C3AED', /* Hover/active of ai-accent (Q5 cleanup rider) */
  // Spec-authorized supporting values (§5, §6)
  textSecondaryDark: '#B8C0CF',
  borderSecondary: '#2A3550',
  alertDark: '#F87171',
};
